import qs from 'qs';
import { matchPath } from 'react-router';
import { Instance } from 'mobx-state-tree';
import { RouterModel } from 'mst-react-router';

import { getCompanyDomain, isCompanyDomain } from '@src/helpers';
import { ROUTES } from 'src/constants';

export const RouterStore = RouterModel.actions(self => ({
  getMatch: function({ path, exact = false, strict = false }) {
    return matchPath(self.location.pathname, {
      path,
      exact,
      strict
    });
  },
  getRouteParams: function(path) {
    const match = this.getMatch({ path });
    return match?.params;
  }
})).views(self => ({
  get isFreelancerRoute() {
    return this.getMatch({ path: ROUTES.freelancers.base });
  },
  get companyDomain() {
    return getCompanyDomain();
  },
  get isCompanyRoute() {
    return isCompanyDomain();
  },
  get searchParams() {
    return qs.parse(self.location.search, { ignoreQueryPrefix: true });
  }
}));

export type IRouterStore = Instance<typeof RouterStore>;
